import { render, staticRenderFns } from "./feature_4.vue?vue&type=template&id=5d3461d3&scoped=true&"
import script from "./feature_4.vue?vue&type=script&lang=js&"
export * from "./feature_4.vue?vue&type=script&lang=js&"
import style0 from "./feature_4.vue?vue&type=style&index=0&id=5d3461d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3461d3",
  null
  
)

export default component.exports